function ModelPerformance() {
  return <div><h2>Model Performance</h2><p>Model accuracy, loss, and logs will go here.</p></div>;
}
export default ModelPerformance; 